import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import modalReducer from './modal';
import loadingReducer from './loading';
import userReducer from './user';
import agreeReducer from './agree';
import createSagaMiddleware from '@redux-saga/core';
import { all } from '@redux-saga/core/effects';
import watchOpen from './modal.saga';

const sagaMiddleware = createSagaMiddleware();
function* rootSaga() {
  yield all([watchOpen()]);
}

export const store = configureStore({
  reducer: {
    modal: modalReducer,
    loading: loadingReducer,
    user: userReducer,
    agree: agreeReducer,
  },
  middleware: [sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
